import React from 'react';
import './styles.scss';

export type NutritionTableProps = {
  rows: {
    cells: string[];
  }[]
};

const NutritionTable = ({rows}: NutritionTableProps) => {

  return (
    <div className={"nutrition-table"}>
      <table>
        <tbody>
          {rows.map((row, index) => {
            return (
              <tr key={`row-${index}`}>
                {row.cells.map((cell, indexCell) => {
                  return cell && (<td key={`cell-${index}-${indexCell}`}>{cell}</td>)
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
};

export default NutritionTable;
